/**
 * Application constants for HotPads Web Next.js app
 */

/**
 * Number of listings to display per page in search results
 */
export const LISTINGS_PER_PAGE = 40;

/**
 * Hash fragment that deep-links to the tour-booking wizard on listing pages.
 * Published as `tourBookingPage` in listing structured data — the opener
 * component and the JSON-LD builder must stay in sync on this value.
 */
export const BOOK_TOUR_HASH = 'book-tour';
